/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';

  /**
   *  Вид для претензии.
   */
  app.ClaimView = app.View.extend({

    events: {
      'click .remove-claim, .with-icon_x-grey': 'removeClaim',
    },
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#claim-template');
      this.listenTo(this.model, 'remove', this.remove);
    },
    render: function () {
      var issuedAt = this.model.get('issued_at');
      var element = this.template({
        model: this.model.toJSON(),
        createdAt: moment(this.model.get('created_at')).format('DD.MM.YYYY / HH:mm'),
        updatedAt: moment(this.model.get('updated_at')).format('DD.MM.YYYY'),
        issuedAt: issuedAt ? moment(issuedAt).format('DD.MM.YYYY / HH:mm') : null,
        isNewBadgeColors: app.features && app.features.is_new_badge_colors,
      });
      this.$el.html(element);
      return this;
    },
    removeClaim: function () {
      this.model.destroy();
    },
  });
})();

}.call(window));